export const auth = {
  clientId: process.env.REACT_APP_AAD_CLIENT_ID!, // eslint-disable-line @typescript-eslint/no-non-null-assertion
  authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}/`,
  redirectUri: '/',
  postLogoutRedirectUri: 'http://example.com',
};

export default auth;
